import { render, staticRenderFns } from "./Project1.vue?vue&type=template&id=5c82c258&scoped=true&"
import script from "./Project1.vue?vue&type=script&lang=js&"
export * from "./Project1.vue?vue&type=script&lang=js&"
import style0 from "./Project1.vue?vue&type=style&index=0&id=5c82c258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82c258",
  null
  
)

export default component.exports